import Swiper from 'swiper';
import Component from '../app/component';
import tweens from '../helpers/tweens';
import api from '../helpers/api';
import gsap from 'gsap'

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      value: 0.0,
      quantity: 1,
      imageIndex: 0,
      indexPackages: 0,
      productSelected: null,
      optionsSelected: {},
      variantId: null,
      redirectOnProductSelection: false
    };
  }

  init() {
    if (this.el.classList.contains('shopptop')) {
      this.data.redirectOnProductSelection = true
    }

    this.initPackagesSlider();
    this.initFeedbackSlider();
    this.initProductsForm();
    this.initMultipacksMobileSlider();

    if (this.refs?.products?.length) {
      this.refs.products.forEach((el) => {
        el.addEventListener('mouseenter', () => {
          document.body.dispatchEvent(new CustomEvent('cursor.display'));
        });
        el.addEventListener('mouseleave', () => {
          document.body.dispatchEvent(new CustomEvent('cursor.hide'));
        });
        el.addEventListener('mousedown', () => {
          document.body.dispatchEvent(new CustomEvent('cursor.click'));
        });
        el.addEventListener('mouseup', () => {
          document.body.dispatchEvent(new CustomEvent('cursor.unclick'));
        });
      });
    }

    if (this.refs.productImage) {
      tweens.tweenFloat(this.refs.productImage);
    }

    // quantity events
    if (this.refs.formQuantityAdd) {
      this.refs.formQuantityAdd.addEventListener('click', () => {
        this.data.quantity += 1;
      });
    }
    if (this.refs.formQuantitySub) {
      this.refs.formQuantitySub.addEventListener('click', () => {
        if (this.data.quantity > 1) {
          this.data.quantity -= 1;
        }
      });
    }

    // submit
    if (this.refs.submitButton) {
      this.refs.submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.submit()
          .then((res) => {
            if (res?.result?.data?.cartLinesAdd?.cart?.id) {
              document.dispatchEvent(new CustomEvent('cart.update'));
            }
          })
          .catch((err) => console.error(err));
      });
    }

    // preload images
    if (window?.__productVariants?.length) {
      window.__productVariants.forEach((item) => {
        if (item?.images?.length) {
          item.images.forEach((imageUrl) => {
            fetch(imageUrl)
          })
        }
      })
    }
  }

  initPackagesSlider() {
    if (!this.refs.sliderPackages) {
      return;
    }

    this.swiperPackages = new Swiper(
      this.refs.sliderPackages,
      {
        loop: true,
        slidesPerView: 1
      }
    );

    this.swiperPackages.on('realIndexChange', () => {
      this.data.indexPackages = this.swiperPackages.realIndex;
    });

    if (this.refs.indexesPackages) {
      this.refs.indexesPackages.forEach((el) => {
        el.addEventListener('click', () => {
          const index = this.refs.indexesPackages.indexOf(el);
          if (this.swiperPackages) {
            this.swiperPackages.slideToLoop(index);
          }
        });
      });
    }
  }

  initMultipacksMobileSlider() {
    if (!this.refs.multipackMobileSlider) {
      return;
    }

    this.multipackMobileSlider = new Swiper(
      this.refs.multipackMobileSlider,
      {
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 6500
        }
      }
    );

    this.refs.sliderMultiPackLeft.addEventListener('click', () => {
      this.multipackMobileSlider.slideNext();
    });

    this.refs.sliderMultiPackRight.addEventListener('click', () => {
      this.multipackMobileSlider.slidePrev();
    });
  }

  initFeedbackSlider() {
    if (!this.refs.sliderFeedback) {
      return;
    }

    this.swiperFeedback = new Swiper(
      this.refs.sliderFeedback,
      {
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 6500
        }
      }
    );

    this.refs.sliderFeedbackLeft.addEventListener('click', () => {
      this.swiperFeedback.slideNext();
    });

    this.refs.sliderFeedbackRight.addEventListener('click', () => {
      this.swiperFeedback.slidePrev();
    });
  }

  initProductsForm() {
    if (!window.__products) {
      return;
    }

    // redirect on product selection
    if (this.data.redirectOnProductSelection) {
      let ignoreFirst = true
      this.refs.formProductsSelect.addEventListener('change', e => {
        if (ignoreFirst) {
          ignoreFirst = false
          return
        }
        const value = e.target.value
        const product = window.__products.filter(item => (item.handle === value && item.url))[0]
        if (product) {
          window.location.href = product.url
        }
      })
    }

    // build products select
    window.__products
      .sort((item1, item2) => {
        if (item1.title < item2.title) {
          return -1;
        } else if (item1.title > item2.title) {
          return 1;
        }
        return 0;
      })
      .forEach((item) => {
        const optionEl = document.createElement('option');
        optionEl.textContent = item.title;
        optionEl.value = item.handle;
        this.refs.formProductsSelect.appendChild(optionEl);
      });

    if (window.__productHandle) {
      setTimeout(() => {
        this.refs.formProductsSelect.value = window.__productHandle;
        const e = new Event('change', {
          bubbles: false,
          cancelable: true
        });
        this.refs.formProductsSelect.dispatchEvent(e);
      }, 100);
    }

    // hide products select on drink page
    if (!this.data.redirectOnProductSelection) {
      this.refs.formProductsSelect.parentNode.parentNode.style.display = 'none'
    }

    // build options radio + click event
    this.refs.formProductsSelect.addEventListener('change', () => {
      if (!this.refs.formOptions) {
        return;
      }
      this.data.productSelected = this.refs.formProductsSelect.value;

      // set options array
      let options = [];
      window.__products.forEach((productItem) => {
        if (productItem.handle === this.refs.formProductsSelect.value) {
          options = productItem.options;
        }
      });

      // reset options
      this.refs.formOptions.innerHTML = '';

      // build options
      options.forEach((option) => {
        let html = `<h5>${option.name.replace(/Pack\s/, '')}</h5><div class="ui-radio">`;
        if (option.values.length) {
          option.values.forEach((optionValue, i) => {
            // set first item as default
            if (i === 0) {
              setTimeout(() => {
                this.data.optionsSelected = Object.assign(
                  this.data.optionsSelected,
                  {
                    [option.name]: optionValue
                  }
                );
              }, 10);
            }
            html += `<div class="ui-radio-button" data-name="${option.name}" data-value="${optionValue}">${optionValue}</div>`;
          });
        }
        html += '</div>';
        this.refs.formOptions.innerHTML += html;
      });

      // options click event
      Array
        .from(this.refs.formOptions.querySelectorAll('.ui-radio-button'))
        .forEach((el) => {
          el.addEventListener('click', () => {
            const variantName = el.dataset.name;
            const variantValue = el.textContent;
            this.data.optionsSelected = Object.assign(
              this.data.optionsSelected,
              {
                [variantName]: variantValue
              }
            );
          });
        });
    });
  }

  watchOptionsSelected(value) {
    if (value && value['Pack Size'] && window.__productVariants?.length) {
      const imageVariant = window.__productVariants.filter(item => item.name === value['Pack Size'])[0]
      if (imageVariant?.images?.length && this.refs.productImage) {
        this.refs.productImage.src = imageVariant.images[0]
      }
      this.refs.productImageIndexes.innerHTML = ''
      if (imageVariant?.images?.length > 1) {
        for (let i = 0; i < imageVariant.images.length; i++) {
          const indexImg = document.createElement('img')
          indexImg.src = this.refs.productImageIndexes.dataset.indexIconUrl
          indexImg.classList.add('shopptop-productimage-index')
          if (i === this.data.imageIndex) {
            indexImg.classList.add('shopptop-productimage-index--active')
          }
          this.refs.productImageIndexes.appendChild(indexImg)
          indexImg.addEventListener('pointerdown', () => {
            this.data.imageIndex = i
          })
        }
      }
    }

    Array
      .from(this.refs.formOptions.querySelectorAll('.ui-radio-button'))
      .forEach((el) => el.classList.remove('ui-radio-button--active'));

    Object
      .keys(value)
      .forEach((key) => {
        const el = this.refs.formOptions.querySelector(`.ui-radio-button[data-name="${key}"][data-value="${value[key]}"]`);
        if (el) {
          el.classList.add('ui-radio-button--active');
        }
      });

    if (Object.keys(value).length) {
      this.loadPriceValue();
    }
  }

  watchImageIndex(value) {
    const packSize = this.data.optionsSelected['Pack Size']
    if (!packSize) {
      return
    }
    const variant = window.__productVariants.filter(item => item.name === packSize)[0]
    if (!variant) {
      return
    }

    // change image
    const images = variant.images
    if (images[value]) {
      const tl = gsap.timeline()

      tl.to(
        this.refs.productImage,
        {
          opacity: 0,
          scale: 0.9,
          ease: 'power2.in',
          duration: 0.5
        }
      )

      tl.call(() => {
        this.refs.productImage.src = images[value]
      })

      tl.to(
        this.refs.productImage,
        {
          opacity: 1,
          scale: 1,
          ease: 'power2.out',
          duration: 0.5,
          clearProps: 'opacity, scale',
          delay: 0.2
        }
      )
    }

    // change index
    Array
      .from(this.refs.productImageIndexes.querySelectorAll('.shopptop-productimage-index'))
      .forEach((el, i) => {
        if (i === value) {
          el.classList.add('shopptop-productimage-index--active')
        }
        else {
          el.classList.remove('shopptop-productimage-index--active')
        }
      })
  }

  watchIndexPackages(value) {
    if (this.refs?.indexesPackages?.length) {
      this.refs.indexesPackages.forEach((el, i) => {
        el.classList.remove('product-packages-index--active');
        if (i === value) {
          el.classList.add('product-packages-index--active');
        }
      });
    }
  }

  watchValue() {
    this.data.quantity = 1;
    this.updateTotal();
  }

  watchQuantity(value) {
    this.refs.formQuantity.textContent = value;
    this.updateTotal();
  }

  watchProductSelected() {
    this.data.quantity = 1;
    this.data.value = 0;
    this.data.optionsSelected = {};
  }

  productIdSelected() {
    if (this.data.productSelected && window?.__products?.length) {
      return window.__products.filter((item) => item.handle === this.data.productSelected)?.[0]?.id;
    }
    return null;
  }

  loadPriceValue() {
    api.fetch('/api/product/variant', {
      productId: this.productIdSelected(),
      options: JSON.stringify(this.data.optionsSelected)
    })
      .then((res) => {
        if (res?.result?.data?.product?.variantBySelectedOptions?.priceV2?.amount) {
          this.data.value = parseFloat(res.result.data.product.variantBySelectedOptions.priceV2.amount);
          this.data.variantId = res.result.data.product.variantBySelectedOptions.id;
        }
      });
  }

  updateTotal() {
    let value = '-';
    if (this.data.value && this.data.quantity) {
      const formatter = new Intl.NumberFormat(
        'it-IT',
        {
          style: 'currency',
          currency: 'EUR',
        }
      );
      value = formatter.format(this.data.quantity * this.data.value);
    }
    this.refs.formPrice.textContent = value;
  }

  submit() {
    const cartId = localStorage.getItem('cartId');
    if (this.data.value > 0 && cartId && this.data.variantId && this.data.quantity) {
      return api.fetch(
        '/api/cart/addline',
        {
          variables: JSON.stringify({
            cartId,
            lines: [{
              merchandiseId: this.data.variantId,
              quantity: this.data.quantity
            }]
          })
        }
      );
    } else {
      return Promise.reject('Required params not matched');
    }
  }
}
